import React, { Suspense } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';
import { getCustomSignupDetails } from '../../../stores/custom-signup/getters';

const OptionKaro = React.lazy(() => import('./CustomBanners/OptionKaro'));
const ProjectWealth = React.lazy(() => import('./CustomBanners/ProjectWealth'));
const TechnoCharts = React.lazy(() => import('./CustomBanners/TechnoCharts'));
const SharekhanExclusive = React.lazy(() =>
  import('./CustomBanners/SharekhanExclusive')
);
const AlphaMonk = React.lazy(() => import('./CustomBanners/AlphaMonk'));

function useIsTargetPage() {
  const targetPaths = ['signup', 'signupform', 'enterotp'];
  const { pathname = '' } = useLocation() || {};
  const formatedPath = pathname.replace('/auth/', '')?.toLowerCase();

  let match = false;

  for (let index = 0; index < targetPaths.length; index++) {
    const targetPath = targetPaths[index];

    if (formatedPath.includes(targetPath?.toLowerCase())) {
      match = true;
      break;
    }
  }

  return match;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    order: 2,
    marginTop: 30,
    marginBottom: 30,
    maxWidth: 406,

    [theme.breakpoints.up('md')]: {
      order: 1,
      marginTop: 0,
      marginBottom: 0,
      marginRight: 80,
    },

    [theme.breakpoints.up('lg')]: {
      marginRight: 140,
    },
  },
  Placeholder: {
    width: 100,
    height: 20,
  },
}));

const CustomAsideWrapper = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </div>
  );
};

const CustomAsideInfo = () => {
  const isTargetPage = useIsTargetPage();
  const customSignupPageName = useSelector((state) => {
    const { name } = getCustomSignupDetails(state);

    return name;
  });

  if (!isTargetPage) {
    return <></>;
  }

  if (customSignupPageName === 'sign_up_page_option_karo') {
    return (
      <CustomAsideWrapper>
        <Suspense>
          <OptionKaro />
        </Suspense>
      </CustomAsideWrapper>
    );
  }

  if (customSignupPageName === 'sign_up_page_project_wealth') {
    return (
      <CustomAsideWrapper>
        <Suspense>
          <ProjectWealth />
        </Suspense>
      </CustomAsideWrapper>
    );
  }

  if (customSignupPageName === 'sign_up_page_techno_charts') {
    return (
      <CustomAsideWrapper>
        <Suspense>
          <TechnoCharts />
        </Suspense>
      </CustomAsideWrapper>
    );
  }

  if (customSignupPageName === 'sign_up_page_sharekhan_exclusive') {
    return (
      <CustomAsideWrapper>
        <Suspense>
          <SharekhanExclusive />
        </Suspense>
      </CustomAsideWrapper>
    );
  }

  if (customSignupPageName === 'sign_up_page_alpha_monk') {
    return (
      <CustomAsideWrapper>
        <Suspense>
          <AlphaMonk />
        </Suspense>
      </CustomAsideWrapper>
    );
  }

  return <></>;
};

export default CustomAsideInfo;
